import React from "react";
import { Modal, modalStyles } from '@futures-platform/ui'
import { requestTranslation } from '@futures-platform/i18n'

const SharedLinkModalAfterDelete = ({
  SharedLinkModalAfterDelete,
  SharedLinkModalAfterDeleteClose,
  RadarTitle
}) => {
  return (
    <Modal
      isOpen={SharedLinkModalAfterDelete}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={{ content: { ...modalStyles.content, padding: '50px 0' }, overlay: { ...modalStyles.overlay, zIndex: 111121 } }}
      onRequestClose={SharedLinkModalAfterDeleteClose}
    >
      <div className="confirmation-modal-content pt-4 pb-4">
        <h3 className="confirmation-modal-title">
          {requestTranslation("sharedLinkDeletedNote")}
        </h3>
        <p style={{textAlign: 'center', marginLeft: '110px', marginRight: '117px'}}>{RadarTitle}</p>
        <div className="confirmation-modal-actions">
          <button
            onClick={SharedLinkModalAfterDeleteClose}
            className="btn btn-lg btn-primary"
          >
            {requestTranslation("ok").toUpperCase()}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SharedLinkModalAfterDelete;
